import {
  FORMULARIOS,
  ALERTA,
  MSG_NENHUM_ARQUIVO_ENCONTRADO,
  MSG_CAMPO_OBRIGATORIO_GERAL,
  MSG_TAMANHO_ARQUIVO_NAO_SUPORTADO,
  MSG_TAMANHO_NOME_ARQUIVO,
} from 'utils/consts';
import { getAssuntoUrl } from 'utils/funcaoPadrao';
import { fetchNotificationApp, fetchStatusModal } from 'store/fetchActions/fetchApp';

export const validarArquivosRequerimentoServico = arquivos => dispatch => {
  if (getAssuntoUrl() === FORMULARIOS.SERVICOS.id && arquivos?.length === 0) {
    dispatch(fetchStatusModal(false, ''));
    fetchNotificationApp(MSG_CAMPO_OBRIGATORIO_GERAL, MSG_NENHUM_ARQUIVO_ENCONTRADO, ALERTA.ERRO);
    return false;
  }
  return true;
};

export const validationNomeTamanhoArquivo = (file, tamanhoTotalMb) => {
  if (file.name.length > 142) {
    fetchNotificationApp('Nome do arquivo inválido', MSG_TAMANHO_NOME_ARQUIVO, ALERTA.AVISO);
    return false;
  }
  if (tamanhoTotalMb > 10) {
    fetchNotificationApp(MSG_TAMANHO_ARQUIVO_NAO_SUPORTADO, '', ALERTA.ERRO);
    return false;
  }
  return true;
};
